// Types
import { Point } from '../../../common/maths/geometry/pointTypes';

/**
 * Determines the size, in pixels, of the current touch event if it has two touch points.
 * I.e. The distance between the two touch points.
 */
export const getGestureSize = (event: TouchEvent): number => {
    const touchA = event.touches.item(0);
    const touchB = event.touches.item(1);

    if (!touchA || !touchB) return 0;

    const dx = touchB.clientX - touchA.clientX;
    const dy = touchB.clientY - touchA.clientY;

    return Math.sqrt(dx * dx + dy * dy);
};

/**
 * Determines the position between the two touch points.
 */
export const getGestureCentre = (event: TouchEvent): Point => {
    const touchA = event.touches.item(0);
    const touchB = event.touches.item(1);

    if (!touchA || !touchB) return { x: 0, y: 0 };

    return {
        x: (touchB.clientX + touchA.clientX) / 2,
        y: (touchB.clientY + touchA.clientY) / 2,
    };
};
